import React, { useMemo } from "react"
import { useMedia } from "@app/hooks/useMedia"
import { Box, BoxProps } from "@chakra-ui/react"

type Props = {
  video: any
  showDesktop?: boolean | null
} & BoxProps

const VideoResponsive: React.FC<Props> = ({ video, showDesktop = null, ...props }) => {
  const { isMedium } = useMedia()

  const resolvedShowDesktop = useMemo(() => {
    if (showDesktop !== null) {
      return showDesktop
    }

    return isMedium
  }, [isMedium, showDesktop])

  const videoFile = useMemo(
    () => (resolvedShowDesktop ? video?.desktopFile?.asset?.url : video?.mobileFile?.asset?.url || video?.desktopFile?.asset?.url),
    [resolvedShowDesktop, video]
  )
  const videoUrl = useMemo(
    () => (resolvedShowDesktop ? video?.desktopUrl : video?.mobileUrl || video?.desktopUrl),
    [resolvedShowDesktop, video]
  )
  const autoplay = video?.autoplay

  return video?.type ? (
    <Box {...props}>
      <video
        src={(videoFile || videoUrl) + "#t=0.1"}
        loop
        autoPlay={autoplay}
        playsInline={autoplay}
        muted={autoplay}
        controls={!autoplay}
        width="100%"
        height="100%"
        preload="auto"
      />
    </Box>
  ) : null
}
export default React.memo(VideoResponsive)
